// PopupBudgetStatus Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ProjectStatus from '../../project/project_status/project_status.jsx'
import Popover from '../../../common/common/popover/popover.jsx'

class PopupBudgetStatus extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      status: PropTypes.string,
      container: PropTypes.any,
      onChange: PropTypes.func,
      bPhase: PropTypes.bool,
      disableEsimateStatus: PropTypes.bool,
      target: PropTypes.object,
      closeDate: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      status: '',
      container: null,
      onChange: null,
      bPhase: true,
      disableEsimateStatus: false,
      target: null,
      closeDate: null
    }
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    const classes = classnames('popup-budgetstatus popup-form', {
      active: this.state.active
    })
    const { status, disableEsimateStatus } = this.props

    return (
      <Popover
        placement='bottom'
        arrowClass='arrowpopover'
        container={this.props.container || this}
        target={this.props.target}
        show={this.state.active}
        onHide={this.hide.bind(this)}
      >
        <div className={classes}>
          <div className='popupcont'>
            <ProjectStatus
              value={status}
              onChange={this.props.onChange}
              bPhase={this.props.bPhase}
              disableEsimateStatus={disableEsimateStatus}
              closeDate={this.props.closeDate}
            />
          </div>
        </div>
      </Popover>
    )
  }
}

export default PopupBudgetStatus
